import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_TEACHERS_LIST, MANAGE_TEACHERS_ADD, MANAGE_TEACHERS_VIEW, MANAGE_TEACHERS_EDIT, MANAGE_TEACHERS_DELETE } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const teachersApi = createApi({

    reducerPath: 'teachersApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/guardian/teacher",
    }),
    tagTypes: ["TeachersList", "TeacherDetails"],
    endpoints: (builder) => ({

        // get teachers list
        getTeachersList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "desc" } }) => ({
                method: "PATCH",
                url: MANAGE_TEACHERS_LIST,
                data: { search, status, page, limit, sort, },
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TeachersList"]
        }),

        // get teachers data
        getTeacherDetail: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_TEACHERS_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TeacherDetails"]
        }),

        // create teacher
        createTeacher: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_TEACHERS_ADD,
                data
            }),
            invalidatesTags: ["TeachersList"]
        }),

        // update teacher
        updateTeacher: builder.mutation({
            query: ({ data, teacherId }) => ({
                method: "PUT",
                url: `${MANAGE_TEACHERS_EDIT}/${teacherId}`,
                data
            }),
            invalidatesTags: ["TeachersList", "TeacherDetails"]
        }),

        // delete teacher
        deleteTeacher: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_TEACHERS_DELETE}/${id}`
            }),
            invalidatesTags: ["TeachersList", "TeacherDetails"]
        })
    }),
})

export const {

    useGetTeachersListQuery,
    useCreateTeacherMutation,
    useDeleteTeacherMutation,
    useUpdateTeacherMutation,
    useGetTeacherDetailQuery

} = teachersApi;